import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type ReactRendererService from 'garaje/services/react-renderer';
import type StateService from 'garaje/services/state';
import type { Root } from 'react-dom/client';

export default class CommunicationsNwsWeatherAlertsController extends Controller {
  @service declare reactRenderer: ReactRendererService;
  @service declare state: StateService;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    const { WeatherAlerts } = await import('reactRichComponents/communication/WeatherAlerts');

    const latitude = this.state.currentLocation.latitude;
    const longitude = this.state.currentLocation.longitude;

    this.root = await this.reactRenderer.render(WeatherAlerts, 'react__nws-weather-alerts', {
      latitude,
      longitude,
    });
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
